// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"480":"544f191d","564":"45d241a7","697":"4b75c6ea","734":"cd18ae49","904":"24636a8a"}[chunkId] + ".css";
};